export class LogiCon {
    public static ALL = 'All';
}
